import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faBan, faCalendarAlt, faRotate } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RecurringSeriesDetail } from '@spike/new-booking-model';
import { useMasterData } from 'hooks';
import { FunctionComponent, useMemo } from 'react';
import { formatRecurringSeriesRule } from '../../utils/recurringSeries';
import styles from './RecurringSeriesView.module.scss';

interface SeriesSummaryCardsProps {
    detail: RecurringSeriesDetail;
}

const card = (icon: IconProp, label: string, value: string) => (
    <div
        key={label}
        className={styles.card}
    >
        <p className={styles.cardLabel}>
            <FontAwesomeIcon icon={icon} />
            {label}
        </p>
        <p className={styles.cardValue}>{value}</p>
    </div>
);

export const SeriesSummaryCards: FunctionComponent<SeriesSummaryCardsProps> = props => {
    const masterData = useMasterData();

    const rule = useMemo(
        () => formatRecurringSeriesRule(props.detail, masterData.scheduleFrecuency ?? []),
        [props.detail, masterData.scheduleFrecuency]
    );

    return (
        <div className={styles.cards}>
            {card(faRotate, 'Frequency', rule.frequency)}
            {card(faCalendarAlt, 'Ends', rule.end)}
            {card(faBan, 'Conflict Rule', rule.conflictRule)}
        </div>
    );
};

export default SeriesSummaryCards;
